import { render } from "./base-header.vue?vue&type=template&id=04fcebea"
import script from "./base-header.vue?vue&type=script&lang=js"
export * from "./base-header.vue?vue&type=script&lang=js"

import "./base-header.vue?vue&type=style&index=0&id=04fcebea&lang=sass"

import exportComponent from "D:\\Afwct\\emis2.0\\emis-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QHeader from 'quasar/src/components/header/QHeader.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QHeader,QToolbar,QBtn,QToolbarTitle,QSpace,QTooltip,QMenu});qInstall(script, 'directives', {ClosePopup});
